import { useSyncExternalStore } from "react";
import { LAYOUT_STORAGE_KEY } from "@/core/constants/keys";

interface LayoutData {
  menuIsOpen: boolean;
}

const DEFAULT: LayoutData = { menuIsOpen: true };

function read(): LayoutData {
  if (typeof window === "undefined") return DEFAULT;
  try {
    const raw = localStorage.getItem(LAYOUT_STORAGE_KEY);
    if (!raw) return DEFAULT;
    return { ...DEFAULT, ...JSON.parse(raw) };
  } catch {
    return DEFAULT;
  }
}

let snapshot = read();
const listeners = new Set<() => void>();

function notify() {
  snapshot = read();
  listeners.forEach((l) => l());
}

export const layoutStore = {
  get: () => snapshot,
  set(partial: Partial<LayoutData>) {
    const next = { ...read(), ...partial };
    localStorage.setItem(LAYOUT_STORAGE_KEY, JSON.stringify(next));
    notify();
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useLayoutStore(): LayoutData {
  return useSyncExternalStore(layoutStore.subscribe, layoutStore.get, () => DEFAULT);
}
